import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {accreditationProfile} from "../../../../../services/session.service";

@Component({
    selector: 'app-accreditation-profile',
    templateUrl: './accreditation-profile.component.html',
    styleUrls: ['./accreditation-profile.component.scss'],
    standalone: false
})
export class AccreditationProfileComponent implements OnInit {

  @Input() profiles: accreditationProfile[];
  @Input() annualUpdate: boolean = false;
  @Output() closeMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() {
  }
}
